var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMountain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m9.933 5.222-.492-.984.492-.985h-2.56v1.97h2.56",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12.295 10.656 10.65 8.791a.563.563 0 0 0-.877.704l.767 1.051a.202.202 0 0 1-.325.239l-.926-1.262-2.143-2.921a1 1 0 0 1-.194-.592V3.468a.214.214 0 0 0-.428 0V6.01a1 1 0 0 1-.193.592l-2.143 2.92-1.383 1.886A1 1 0 0 0 3.61 13h8.538c.86 0 1.32-1.016.75-1.662z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain);
export default __webpack_public_path__ + "static/media/mountain.05384788b3b46c82ae9227d3299ebedd.svg";
export { ForwardRef as ReactComponent };